<template>
  <div class="content" :id="id">
    <div class="box">
      <div class="top-title">日本签证</div>
      <!--      <div class="middle-title">日本ビザ</div>-->
      <div class="bottom-box">
        <div class="common middle-btn" @click="toMakeAppointment()">
          <div class="btn-item">
            <img src="../../../assets/images/icon_visa_japan_my_order.png">
            <img src="../../../assets/images/icon_visa_japan_my_order_.png" alt="">
            <span>我要预约</span>
          </div>
        </div>
        <!--  我要预审的函数   放到@clickz就可以  功能已经完善 toPreliminaryExamination() -->
        <div class="common middle-btn" @click="openModal">
          <div class="btn-item">
            <img src="../../../assets/images/icon_function_online_work.png" alt="">
            <img src="../../../assets/images/icon_visa_japan_my_examine_.png">
            <span>我要预审</span>
          </div>

        </div>
        <div class="common middle-btn" @click="toQuery()">
          <div class="btn-item">
            <img src="../../../assets/images/icon_visa_japan_my_search.png">
            <img src="../../../assets/images/icon_visa_japan_my_search_.png" alt="">
            <span>我要查询</span>
          </div>
          <a-modal v-model="visible" title="提示" :footer="null">
            <div class="icon-tabd">
              <img src="../../../assets/images/icon_construction.png" alt="" />
              <div class="icon-tabdd">抱歉！我们正在努力建设中~~</div>
              <!--              <div slot="footer">-->
              <!--                <a-button type="primary" @click="handleOk">确定</a-button>-->
              <!--              </div>-->
            </div>
          </a-modal>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'japan-visa',
  props: {
    id: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      visible: false,
    }
  },
  methods: {
    jumpNewUrl (url) {
      window.open(url)
    },
    turnToReserve (val) {
      this.$router.push('/JapanVisa?key=' + val)
    },
    openModal () {
      this.visible = true
    },
    handleOk () {
      this.visible = false
    },
    toMakeAppointment () { //前往我要预约
      this.$router.push('/specialServiceInformation?linkname=我要预约')
    },
    toPreliminaryExamination () {  //前往我要预审
      this.$router.push('/PreliminaryExamination?linkname=我要预审')
    },
    toQuery () {  //前往我要查询
      this.$router.push('/query?linkname=我要查询')
    }
  }
}
</script>

<style scoped lang='less'>
.icon-tabd {
  // border:none;
  width: 100%;
  height: 250px;
  img {
    margin: 0 117px 0 117px;
  }
  .icon-tabdd {
    text-align: center;
  }
}
.icon-tabdd {
  font-family: MicrosoftYaHei;
  font-weight: Regular;
  margin-top: 20px;
  color: #aaaaaa;
}
.content {
  width: 100%;
  position: relative;
  height: 260px;
  margin-top: 40px;
  margin-bottom: 47px;
}
.box {
  width: 1140px;
  height: 260px;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  position: relative;
  margin: auto;
  background: rgba(203, 180, 134, 1);
}
.top-title {
  height: 35px;
  line-height: 35px;
  font-size: 35px;
  display: inline-block;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  margin: 54px auto;
  //width: 100%;
  //text-align: center;
  //margin-top: 54px;
}
.middle-title {
  height: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #faf5f5;
  opacity: 0.68;
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.bottom-box {
  //margin-top: 36px;
  padding: 0 79px;
  text-align: left;
}

.common {
  width: 112px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  height: 80px;
  display: inline-block;
  img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.left-btn {
  margin-left: 164px;
}
.middle-btn:hover {
  background: white;
  color: rgba(0, 0, 0, 1);
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
  img:first-of-type {
    display: none;
  }
  img:last-of-type {
    display: inline-block;
  }
}
.middle-btn {
  margin: 0 32px;
  width: 260px;
  height: 80px;
  background: transparent;
  border: 0px solid #e5e5e5;
  /* margin-left: 165px; */
  color: white;
  padding-top: 6px;
  text-align: center;
  img {
    width: 32px;
    height: 32px;
    margin: auto 0;
    vertical-align: middle;
    cursor: pointer;
    transform: translateY(1px);
  }
  img:first-of-type {
    display: inline-block;
  }
  img:last-of-type {
    display: none;
  }
  span {
    vertical-align: bottom;
  }
}
.right-btn {
  margin-left: 167px;
}
span {
  vertical-align: bottom;
  cursor: pointer;
}
.btn-item {
  height: 32px;
  line-height: 32px;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/goaboard/siderContent-01.vue